module.exports = __webpack_public_path__ + "img/docx-image.f33a11ed.png";